
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AGENT_CATEGORIES } from "@/models/agent-form";

interface CategorySelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const CategorySelect: React.FC<CategorySelectProps> = ({ value, onChange, error }) => {
  // Ensure categories are unique by using a Set
  const uniqueCategories = [...new Set(AGENT_CATEGORIES)];
  
  return (
    <div className="space-y-2">
      <Select 
        value={value}
        onValueChange={onChange}
      >
        <SelectTrigger 
          id="category" 
          className={error ? "border-destructive" : ""}
        >
          <SelectValue placeholder="Select a category" />
        </SelectTrigger>
        <SelectContent>
          {uniqueCategories.map((category) => (
            <SelectItem key={category} value={category}>{category}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && (
        <p className="text-sm text-destructive">{error}</p>
      )}
    </div>
  );
};

export default CategorySelect;
